import { Info, OctagonAlert, TriangleAlert } from "lucide-react";
import { severityLabel } from "../../shared/findings";
import type { Severity } from "../../shared/api";
import { cn } from "@/lib/utils";

export type Tone = "success" | "warning" | "critical" | "info";

// Tam sınıf adları yazılı kalmalı: Tailwind dinamik birleştirilen adları görmez.
const TONE: Record<Tone, string> = {
  success: "bg-success text-success-foreground border-success-border",
  warning: "bg-warning text-warning-foreground border-warning-border",
  critical: "bg-critical text-critical-foreground border-critical-border",
  info: "bg-info text-info-foreground border-info-border",
};

const ICON = { critical: OctagonAlert, warning: TriangleAlert, info: Info } as const;

/** Durum rozeti (ui.md §6.1). Metni (✓ ⚠ ✗ dahil) çağıran verir. */
export function StatusBadge({ tone, className, children }: { tone: Tone; className?: string; children: React.ReactNode }) {
  return (
    <span data-slot="status-badge" data-tone={tone} className={cn("inline-flex w-fit shrink-0 items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium [&>svg]:size-3", TONE[tone], className)}>
      {children}
    </span>
  );
}

/** Şiddet rozeti: ikon (aria-hidden) + metin. */
export function SeverityBadge({ severity }: { severity: Severity }) {
  const Icon = ICON[severity];
  return (
    <StatusBadge tone={severity}>
      <Icon aria-hidden="true" />
      {severityLabel[severity]}
    </StatusBadge>
  );
}
